interface WazeButtonProps {
  url?: string;
}
import wazeIcon from "../../../assets/waze.svg";
export default function WazeButton({ url }: WazeButtonProps) {
  return (
    <a
      href={url || "https://waze.com/ul?navigate=yes"}
      target="_blank"
      rel="nofollow noopener noreferrer"
      className="fixed bottom-6 right-4 z-50 w-14 h-14 flex items-center justify-center rounded-full border-[3px] border-gray-900 cursor-pointer transition-transform hover:scale-110 overflow-hidden"
      style={{
        background: "#05C8F7",
        boxShadow: "0 4px 12px rgba(5, 200, 247, 0.35)",
        animation: "pulse-waze 2.5s infinite",
      }}
      aria-label="פתח ב-Waze"
    >
      <img
        src={wazeIcon}
        alt="Waze"
        className="w-8 h-8 object-contain brightness-0 invert"
      />
      <style>{`
        @keyframes pulse-waze {
          0%, 100% { box-shadow: 0 4px 12px rgba(5, 200, 247, 0.35); }
          50% { box-shadow: 0 4px 20px rgba(5, 200, 247, 0.6); }
        }
      `}</style>
    </a>
  );
}
